import { Organization } from '../../interfaces/api/organization';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OrganizationFilterParameters } from '../../api/organizations';
import { fetchOrganizations } from '../services/organization.service';

interface OrganizationState {
	organizations: Record<number, Organization>;
	selectedOrganization: Organization | undefined;
	isLoading: boolean;
}

const initialState: OrganizationState = {
	organizations: [],
	selectedOrganization: undefined,
	isLoading: false,
};

export const fetchOrganizationsThunk = createAsyncThunk<
	Organization[],
	{ params: OrganizationFilterParameters }
>('organization/fetchOrganizations', async ({ params }, { rejectWithValue }) => {
	try {
		return await fetchOrganizations(params);
	} catch (error) {
		return rejectWithValue(error);
	}
});

const organizationSlice = createSlice({
	name: 'organization',
	initialState,
	reducers: {
		selectOrganization: (state, action: PayloadAction<number>) => {
			state.selectedOrganization = state.organizations[action.payload];
			localStorage.setItem('selectedOrganization', String(state.organizations[action.payload].id));
		},
		unSelectOrganization: (state) => {
			state.selectedOrganization = undefined;
			localStorage.removeItem('selectedOrganization');
		},
		resetOrganization: (state) => {
			Object.assign(state, initialState);
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchOrganizationsThunk.fulfilled, (state, action) => {
			const ret: Record<number, Organization> = {};
			state.organizations = action.payload.reduce((obj, organization) => {
				obj[organization.id] = organization;
				return obj;
			}, ret);
			const selectedStorageOrganization: string | null =
				localStorage.getItem('selectedOrganization');
			if (selectedStorageOrganization && state.organizations[Number(selectedStorageOrganization)]) {
				state.selectedOrganization = state.organizations[Number(selectedStorageOrganization)];
			}
			state.isLoading = false;
		});
		builder.addCase(fetchOrganizationsThunk.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchOrganizationsThunk.rejected, (state, _action) => {
			state.organizations = [];
			state.isLoading = false;
		});
	},
});

export const { selectOrganization, unSelectOrganization, resetOrganization } =
	organizationSlice.actions;

export default organizationSlice;
